module.exports = "<div id=\"Container\">\r\n    <router-outlet></router-outlet>\r\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app.component.html
 ** module id = 34
 ** module chunks = 0
 **/